'use client'

import React from 'react'
import Image from 'next/image'

import { Link } from '@/i18n/navigation'

import { ServicesType } from '../types'
import { ModuleTitle } from '../'

import styles from './whyChooseUs.module.css'

type ServicesProps = {
  blockData: ServicesType
}

const WhyChooseUs = ({ blockData }: ServicesProps) => {
  return (
    <div className="flex w-full items-center justify-center px-7 max-xl:justify-start max-xl:overflow-hidden max-xl:px-0">
      <div className="flex flex-col justify-center max-xl:w-full max-xl:items-start 2xl:max-w-[1440px]">
        <div className="max-xl:px-4">
          <ModuleTitle title={blockData?.title} viewAll="" />
        </div>
        <div className={`max-xl:w-full max-xl:overflow-x-auto ${styles.whychooseus}`}>
          <div className="flex justify-center gap-[16px] max-xl:w-fit max-xl:justify-start max-xl:px-4">
            {blockData?.items?.map((item, index) => (
              <Link href={item?.link} key={index}>
                <div
                  className={`flex flex-col items-center justify-center gap-[24px] rounded-[20px] bg-[#F8F8F9] px-[32px] py-[75.5px] max-xl:w-[248px] max-xl:gap-[8px] max-xl:px-[32px] max-xl:py-[24px]`}>
                  <div>
                    <Image
                      src={item?.icon}
                      width={80}
                      height={80}
                      alt=""
                      className="max-xl:h-[48px] max-xl:w-[48px]"
                    />
                  </div>
                  <div className="flex flex-col items-center justify-center gap-[16px] max-xl:gap-[4px]">
                    <div className="text-center text-[24px] leading-[29px] max-xl:text-[16px] max-xl:leading-[22px]">
                      {item?.title}
                    </div>
                    <div className="flex items-center justify-center text-center text-[14px] leading-[1.4] text-[#6E6E73] max-xl:text-[12px] max-xl:leading-[1.2]">
                      {item?.subtitle}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyChooseUs
